import styled from 'styled-components'
import FormControl from 'react-bootstrap/FormControl'

export default styled(FormControl)`
  background-color: #00000000;
  border-color: ${(props) => props.theme.text};
  color: white;
  caret-color: white;

  ::placeholder {
    color: white !important;
  }

  &:focus {
    background-color: #00000000;
    box-shadow: none;
    color: white;
  }
`
